import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Hook para o formulário de movimentação de estoque (entrada/saída).
 * Cuida de: seleção de tipo → carregar cores associadas, validação, submit.
 */
export default function useMovementForm({ mode, onSaved }) {
  const isEntry = mode === "in";
  const [type, setType] = useState("");
  const [colors, setColors] = useState([]);
  const [loadingColors, setLoadingColors] = useState(false);
  const [color, setColor] = useState("");
  const [qty, setQty] = useState("");
  const [note, setNote] = useState("");
  const [collabCode, setCollabCode] = useState("");
  const [collabPassword, setCollabPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setColor("");
    if (!type) { setColors([]); return; }
    setLoadingColors(true);
    api.get("/cup-colors", { params: { type } })
      .then(({ data }) => setColors(data.filter((c) => c.active !== false)))
      .catch(() => setColors([]))
      .finally(() => setLoadingColors(false));
  }, [type]);

  const validate = () => {
    if (!type) return "Escolha o produto";
    if (!color) return "Escolha a cor";
    const n = parseInt(qty, 10);
    if (!n || n <= 0) return "Informe uma quantidade válida";
    if (!collabCode || !collabPassword) return "Informe o código e a senha do colaborador";
    return null;
  };

  const submit = async () => {
    setError("");
    const msg = validate();
    if (msg) { setError(msg); return; }
    const n = parseInt(qty, 10);
    setSaving(true);
    try {
      await api.post("/inventory/adjust", {
        type,
        color,
        delta: isEntry ? n : -n,
        note: note || null,
        collaborator_code: collabCode,
        collaborator_password: collabPassword,
      });
      onSaved();
    } catch (e) {
      setError(e?.response?.data?.detail || "Erro ao salvar");
      setSaving(false);
    }
  };

  return {
    isEntry,
    type, setType,
    colors, loadingColors,
    color, setColor,
    qty, setQty,
    note, setNote,
    collabCode, setCollabCode,
    collabPassword, setCollabPassword,
    saving, error,
    submit,
  };
}
